import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLInt,
  GraphQLList,
  GraphQLNonNull,
  GraphQLID
} from 'graphql';

import { connectionArgs, connectionFromArray, connectionDefinitions } from 'graphql-relay';

import CourseType from './course.gql';
import AssignInfoType from './assignInfo.gql';
import CurriculumPerformanceType from './curriculumPerformance.gql';
import CurriculumSectionType from './curriculumSection.gql';
import TagType from './tag.gql';
import UserType from './user.gql';
import Node from './node.gql';

const curriculumType = new GraphQLObjectType({
  name: 'Curriculum',
  fields: () => ({
    id: {
      type: new GraphQLNonNull(GraphQLID),
      resolve: item => item.id
    },
    pid: {
      type: GraphQLString,
      resolve: item => item.pid
    },
    name: {
      type: GraphQLString,
      resolve: item => item.name
    },
    totalCourses: {
      type: GraphQLInt,
      resolve: item => item.totalCourses
    },
    courses: {
      type: new GraphQLList(CourseType),
      resolve: item => item.courses.slice()
    },
    completedCount: {
      type: GraphQLInt,
      args: {
        userId: {
          type: GraphQLString
        }
      },
      resolve: (item) => {
        if (item.completedCount) {
          const value = parseInt(item.completedCount.value, 10);
          return value;
        }
        return 0;
      }
    },
    assignInfoCurriculum: {
      type: AssignInfoType,
      args: {
        userId: {
          type: GraphQLString
        }
      },
      resolve: item => item.assignInfoCurriculum
    },
    description: {
      type: GraphQLString,
      resolve: item => item.description
    },
    image: {
      type: GraphQLString,
      resolve: item => item.image
    },
    curriculumPerformance: {
      type: CurriculumPerformanceType,
      args: {
        userId: {
          type: GraphQLString
        }
      },
      resolve: item => item.curriculumPerformance
    },
    curriculumTags: {
      type: new GraphQLList(TagType),
      resolve: item => item.curriculumTags.slice()
    },
    teacherCurriculum: {
      type: connectionDefinitions({ nodeType: UserType }).connectionType,
      args: connectionArgs,
      resolve: (item, args) => connectionFromArray(item.teacherCurriculum.slice(), args)
    },
    filters: {
      type: new GraphQLList(GraphQLString),
      resolve: (item) => {
        const rFiltersArray = [];
        item.filters.forEach((rFilterObject, index) => {
          rFiltersArray[index] = rFilterObject.value;
        });
        return rFiltersArray;
      }
    },
    courseLockData: {
      type: GraphQLString
    },
    sections: {
      type: new GraphQLList(CurriculumSectionType),
      resolve: item => item.sections
    }
  }),
  interfaces: [Node.nodeInterface]
});

window[curriculumType.name + 'GQLType'] = curriculumType;

export default curriculumType;
